import { IModule } from './types';

export const MaintenancePackage: IModule = {
    name: 'maintenancePackage',
    route: 'maintenance-packages',
};
